export const environment = {
  production: false,
  googleSheetsApiKey: 'AIzaSyDmK4yjRhhOG69cUL6RI8A1PLfPvBIynek'
};
